import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién empiezo como terapeuta natural?',
    a: 'Especialmente si recién empiezas. El sistema te da la estructura clínica desde el primer paciente. No tienes que improvisar ni esperar años de experiencia para trabajar con protocolos respaldados por ciencia. El Volumen I y II son tu base enciclopédica, el III tu laboratorio, el IV tu criterio clínico y el V te abre un mundo de preparaciones avanzadas cuando estés listo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al completar tu compra recibes un correo con acceso inmediato a todos los archivos PDF. También puedes descargarlos directamente desde la plataforma. El acceso es de por vida.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'Puedes pagar en dólares estadounidenses o en la moneda local de tu país. El sistema convierte automáticamente según tu ubicación. Aceptamos tarjeta de crédito, débito y medios de pago locales en toda Latinoamérica.'
  }, {
    q: '¿Necesito imprimirlo todo?',
    a: 'No es necesario. Todo el material está optimizado para usarse en tablet, computadora o celular. Si prefieres tenerlo físico, las planillas de los bonus están especialmente diseñadas para imprimir.'
  }, {
    q: '¿Qué diferencia a este kit de la información que puedo buscar gratis en internet?',
    a: 'La información en internet está dispersa, sin estructura clínica, sin dosificación profesional y sin criterio de seguridad. Este kit tiene fichas validadas con fuentes científicas internacionales, protocolos listos para aplicar, tabla de interacciones y semáforo de riesgo por paciente. Es la diferencia entre datos sueltos y un sistema clínico completo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si no es lo que esperabas, escribes a soportelumenakasha@gmail.com y devolvemos el 100% de tu pago.'
  }, {
    q: '¿Puedo compartirlo con otros terapeutas?',
    a: 'El kit es de uso personal. Cada terapeuta necesita su propio acceso para respetar el trabajo de desarrollo de este material.'
  }, {
    q: '¿Las plantas del kit se consiguen en cualquier país de Latinoamérica?',
    a: 'Sí. El kit está diseñado con plantas de distribución global con presencia en toda Latinoamérica. Cada ficha incluye el nombre científico para que puedas identificarla con su nombre local en cualquier país hispanohablante.'
  }, {
    q: '¿Sirve solo para fitoterapeutas o también para otros profesionales de salud?',
    a: 'Está diseñado para cualquier profesional que trabaje con plantas medicinales: fitoterapeutas, naturópatas, médicos naturistas, nutricionistas, terapeutas holísticos, herbolarios, estudiantes avanzados y profesionales de salud que quieran incorporar fitoterapia clínica a su práctica.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-75" data-mp="3uuppyy8d40j9">
      <div className="text-center mb-12" data-id="element-76" data-mp="3uvradtb9pzdn">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-purpleDark" data-id="element-77" data-mp="2puefjgngdpu">
          <span className="mr-3" data-id="element-78" data-mp="7of78xtknv49">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-79" data-mp="cgyuynlz46ms">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-purple/25 bg-white/80" data-id="element-80" data-mp="hf0etar849zb" data-mpi={i}>
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-81" data-mp="mduwg9dgfshu">
              <span className="font-medium pr-8 text-brand-purpleDark text-[14px] md:text-base lg:text-lg" data-id="element-82" data-mp="vf1gutj85ngd">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" data-mp="2s95veupw4l03" />
            </button>
            <AnimatePresence data-id="element-84" data-mp="21uenn7mz02pc">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-85" data-mp="1wx51c0uvo75q">
                  <div className="px-6 pb-5 text-brand-text border-t border-brand-purple/20 pt-4 bg-white/60 text-[13px] md:text-base leading-relaxed" data-id="element-86" data-mp="1j58f2dfw4rh9">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};